import React from 'react';
import { Modal, Table } from 'antd';
import { IitineraryVendor } from '../Ticket/types/TicketTypes';
import { ColumnsType } from 'antd/es/table';
import useGetSearchColumnProps from '../../../../common/hooks/SearchData';
import { pagination } from '../../../../common/utils/common.utils';

type Props = {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: () => void;
  isModalOpen: boolean;
  vendors: IitineraryVendor[];
};
const ViewVendors = ({ setIsModalOpen, isModalOpen, vendors }: Props) => {
  const searchColumnProps = useGetSearchColumnProps<IitineraryVendor>();

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const column: ColumnsType<IitineraryVendor> = [
    {
      title: 'SL.',
      render: (_, data, index) => <> {index + 1} </>,
    },
    {
      title: 'Vendor',
      dataIndex: 'vendor_name',
      key: 'vendor_name',
      ...searchColumnProps('vendor_name'),
    },
    {
      title: 'Cost Price',
      dataIndex: 'itnrvendor_cost_price',
      key: 'itnrvendor_cost_price',
    },
  ];

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        title='Vendor Information'
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Table
          dataSource={vendors}
          bordered
          columns={column}
          rowKey={(record) =>
            record.vendor_name + ' ' + record.itnrvendor_cost_price
          }
          size='small'
          pagination={pagination(vendors.length)}
        />
      </Modal>
    </>
  );
};

export default ViewVendors;
